export const messages = {
  en: {
    storeOrderLogistics: {
      queryCondition: 'Query Conditions',
      orderLogistics: 'Order Logistics',
      query: 'Query',
      orderId: 'Order ID',
      solNum: 'Logistics Number', 
      solCompany: 'Logistics Company',
      username: 'Recipient',
      address: 'Shipping Address',
      tel: 'Contact Number',
      state: 'Status',
      curPos: 'Current Location',
      remark: 'Order Remarks',
      createTime: 'Create Time',
      operation: 'Operation',
      orderDetail: 'Order Detail',
      logistics: 'Logistics',
      logisticsInfo: 'Logistics Information',
      close: 'Close',
      orderIdPlaceholder: 'Please enter order ID',
      solNumPlaceholder: 'Please enter logistics number',
      solCompanyPlaceholder: 'Please enter logistics company',
      statePlaceholder: 'Please select status'
    }
  },
  zh: {
    storeOrderLogistics: {
      queryCondition: '查询条件',
      orderLogistics: '订单物流',
      query: '查询',
      orderId: '订单ID',
      solNum: '物流编号',
      solCompany: '物流公司',
      username: '收货人',
      address: '收货地址',
      tel: '联系电话',
      state: '状态',
      curPos: '当前位置',
      remark: '订单备注',
      createTime: '创建时间',
      operation: '操作',
      orderDetail: '订单详情',
      logistics: '物流',
      logisticsInfo: '物流信息',
      close: '关闭',
      orderIdPlaceholder: '请输入订单ID',
      solNumPlaceholder: '请输入物流编号',
      solCompanyPlaceholder: '请输入物流公司',
      statePlaceholder: '请选择状态'
    }
  }
}